import { render, staticRenderFns } from "./AuthSuccess.vue?vue&type=template&id=61f5cb24&scoped=true&"
import script from "./AuthSuccess.vue?vue&type=script&lang=ts&"
export * from "./AuthSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./AuthSuccess.vue?vue&type=style&index=0&id=61f5cb24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f5cb24",
  null
  
)

export default component.exports